import React, { Component } from 'react';
import { Row } from './style';
import { Input } from '../InputContainer';
import { Text } from '../../../UI/Text';
import { selectInputContentOnFocus } from '../../../../Utils';

export class DurationInput extends Component {
    state = {
        hours: '00',
        minutes: '00',
        seconds: '00',
    };

    getInitialState = () => {
        const { initial } = this.props;

        const time = initial.split(':');
        const initialState = {
            hours: time[0],
            minutes: time[1],
            seconds: time[2],
        };

        this.setState(initialState);
    };

    componentDidMount() {
        this.getInitialState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initial !== this.props.initial) this.getInitialState();
    }

    handleInputChange = ({ target }) => {
        const { passData, name } = this.props;
        this.setState({ [target.name]: target.value }, () => {
            passData(this.state, name);
        });
    };

    render() {
        const {
            state: { hours, minutes, seconds },
            props: { component, name, ...props },
            handleInputChange,
        } = this;

        const InputComponent = component;

        return (
            <Row>
                <Input>
                    <SelectOnFocusInput
                        component={InputComponent}
                        name={'hours'}
                        onChange={handleInputChange}
                        value={hours}
                        {...props}
                    />
                </Input>
                <Text>:</Text>
                <Input>
                    <SelectOnFocusInput
                        component={InputComponent}
                        name={'minutes'}
                        onChange={handleInputChange}
                        value={minutes}
                        {...props}
                    />
                </Input>
                <Text>:</Text>
                <Input>
                    <SelectOnFocusInput
                        component={InputComponent}
                        name={'seconds'}
                        onChange={handleInputChange}
                        value={seconds}
                        {...props}
                    />
                </Input>
            </Row>
        );
    }
}

// TODO: make as HOC
const SelectOnFocusInput = ({ component, ...props }) => {
    const InputComponent = component;
    return <InputComponent onFocus={selectInputContentOnFocus} autoComplete={'off'} {...props} />;
};

export default DurationInput;



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/DurationInput/index.js